module.exports = __webpack_public_path__ + "img/KA.d28e4a54.png";